import { noddiAsync, URLKeys } from 'noddi-async';
import { PaginatedResponse, TireHotelContractItem } from 'noddi-types';
import { useAuthContext } from 'noddi-web';

import { t, Trans } from '@lingui/macro';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import changeTire from '../../assets/images/change_wheel_best_drive.jpg';
import hurtigRutaRepair from '../../assets/images/performing-hurtig-ruta.jpg';
import { ApiErrorPageWithTrans } from '../../components/ApiErrorPageWithTrans';
import { NoddiLoadingScreenWithTrans } from '../../components/NoddiLoadingScreenWithTrans';
import { useCurrentTheme } from '../../stores/themeStore';
import { ContractCard } from './ContractCard';

interface TireHotelPropsimport {
  showHeading?: boolean;
}

export const TireHotelContent = ({ showHeading }: TireHotelPropsimport) => {
  const { currentUserGroupId } = useAuthContext();

  // This fetch looks a bit silly, its just to get results.count, so we send them to the fleet or normal card.
  const {
    data: contracts,
    isPending,
    error
  } = noddiAsync.useGet({
    type: URLKeys.getPaginatedTireHotelContracts,
    input: {
      userGroupId: currentUserGroupId as number,
      page: 1,
      pageSize: 1
    },
    queryConfig: {
      enabled: !!currentUserGroupId
    }
  });

  if (isPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (!currentUserGroupId || error) {
    return <ApiErrorPageWithTrans error={[error]} />;
  }

  return <TireHotel showHeading={showHeading} contracts={contracts} />;
};

const TireHotel = ({
  showHeading,
  contracts
}: {
  showHeading?: boolean;
  contracts: PaginatedResponse<TireHotelContractItem[]>;
}) => {
  const currentTheme = useCurrentTheme();
  if (!contracts.count) {
    return null;
  }

  function getImage() {
    if (currentTheme === 'carglass') {
      return hurtigRutaRepair;
    }

    if (currentTheme === 'bestdrive') {
      return changeTire;
    }

    return '/assets/images/wc.jpg';
  }

  return (
    <div className='flex flex-col gap-2 md:gap-4'>
      {showHeading && (
        <h2 className='font-bold text-xl text-primary md:text-3xl'>
          <Trans>Tire hotel</Trans>
        </h2>
      )}
      {contracts.count === 1 ? (
        <ContractCard tireHotelContract={contracts.results[0]!} />
      ) : (
        <NoddiBasicCard
          to={customerRoutes.fleetTireHotel.getPath()}
          className='flex flex-col gap-3 overflow-hidden p-0'
        >
          <img src={getImage()} alt={t`Noddi wheel change`} />
          <div className='flex flex-col gap-3 px-6 pb-4'>
            <p>
              <Trans>You have</Trans>
              <span className='font-bold'> {contracts.count}</span> <Trans>cars on our tire hotel</Trans>
            </p>

            <NoddiDummyButton endIcon='ArrowRight' className='w-full'>
              <Trans>Manage my tire hotel</Trans>
            </NoddiDummyButton>
          </div>
        </NoddiBasicCard>
      )}
    </div>
  );
};
